// src/data/comedians/kevin-hart.js

const base = {
  id: 'kevin-hart',
  slug: 'kevin-hart',
  name: 'Kevin Hart',
  birthYear: 1979,
  image: require('@/assets/images/img_Kevin_Hart.jpg'),
  famousWorks: [
    'Laugh at My Pain (2011)',
    'Let Me Explain (2013)',
    'What Now? (2016)',
    'Irresponsible (2019)',
    'Jumanji series',
    'Ride Along series',
    'Central Intelligence (2016)',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'American',
    shortBio: 'High-energy comedy powerhouse',
    bio: `Kevin Hart is an American comedian and actor who has become one of the highest-grossing stand-up comedians and most recognizable entertainment figures worldwide. His energetic performance style and relatable humor about family, relationships, and everyday life have made him a global phenomenon.\n\nBorn in Philadelphia, Hart began his comedy career performing at amateur nights in local clubs. After years of persistence and refinement of his craft, he broke through with his Comedy Central special "I'm a Grown Little Man" in 2009, followed by the massively successful "Laugh at My Pain" tour.\n\nHart has since dominated both stand-up comedy and film, starring in numerous box office hits while continuing to sell out arenas worldwide. His tours consistently break attendance records, and his work ethic and business acumen have established him as one of entertainment's most successful entrepreneurs.`,
    style: 'High-energy, self-deprecating, physical comedy, relatable storytelling',
    achievements: [
      'Multiple sold-out arena tours',
      'Highest-grossing comedy tours worldwide',
      'Time 100 most influential people',
      'Producers Guild Award',
      'Successful production company',
      'Hollywood Walk of Fame star',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Américain',
    shortBio: 'Moteur comique à haute énergie',
    bio: `Kevin Hart est un comédien et acteur américain devenu l'un des stand-uppers les plus rentables et les plus reconnus au monde. Son style de performance énergique et son humour accessible sur la famille, les relations et la vie quotidienne en ont fait un phénomène mondial.\n\nNé à Philadelphie, Hart a débuté sa carrière dans la comédie lors de nuits amateurs dans des clubs locaux. Après des années de persévérance et de perfectionnement, il a percé avec son spécial Comedy Central "I'm a Grown Little Man" en 2009.\n\nHart domine depuis la comédie stand-up et le cinéma, jouant dans de nombreux succès au box-office tout en continuant à faire salle comble dans des arènes du monde entier. Son éthique de travail et son sens des affaires en ont fait l'un des entrepreneurs les plus prospères du divertissement.`,
    style: 'Haute énergie, autodérision, comédie physique, récit accessible',
    achievements: [
      'Multiples tournées sold-out dans des arènes',
      'Tournées de comédie les plus rentables au monde',
      'Time 100 personnalités les plus influentes',
      'Producers Guild Award',
      'Société de production prospère',
      'Étoile sur le Hollywood Walk of Fame',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Americano',
    shortBio: 'Central eléctrica de la comedia de alta energía',
    bio: `Kevin Hart es un comediante y actor estadounidense que se ha convertido en uno de los comediantes de stand-up más taquilleros y reconocidos del mundo. Su estilo de actuación enérgico y su humor cercano sobre la familia, las relaciones y la vida cotidiana lo han convertido en un fenómeno global.\n\nNacido en Filadelfia, Hart comenzó su carrera cómica actuando en noches de aficionados en clubs locales. Tras años de perseverancia y perfeccionamiento de su arte, triunfó con su especial de Comedy Central "I'm a Grown Little Man" en 2009.\n\nHart ha dominado desde entonces tanto el stand-up como el cine, protagonizando numerosos éxitos de taquilla mientras continúa llenando recintos en todo el mundo. Su ética de trabajo y perspicacia empresarial lo han establecido como uno de los emprendedores más exitosos del entretenimiento.`,
    style: 'Alta energía, autodespreciativo, comedia física, narrativa cercana',
    achievements: [
      'Múltiples giras de arena agotadas',
      'Giras de comedia más taquilleras del mundo',
      'Time 100 personas más influyentes',
      'Producers Guild Award',
      'Empresa de producción exitosa',
      'Estrella en el Paseo de la Fama de Hollywood',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'أمريكي',
    shortBio: 'قوة كوميدية مفعمة بالطاقة',
    bio: `كيفن هارت كوميدي وممثل أمريكي أصبح أحد أعلى كوميديي الستاند أب دخلاً وأكثرهم شهرةً في العالم. أسلوبه المفعم بالطاقة وفكاهته العفوية حول الأسرة والعلاقات والحياة اليومية جعلا منه ظاهرة عالمية.\n\nوُلد في فيلادلفيا وبدأ مسيرته الكوميدية في ليالي الهواة بالنوادي المحلية. بعد سنوات من المثابرة وصقل الموهبة، اخترق العالمية بعرضه الخاص على Comedy Central عام 2009.\n\nأصبح هارت منذ ذلك الحين يهيمن على الستاند أب والسينما، مجسّدًا أدوارًا في أفلام ناجحة بينما يواصل ملء الملاعب حول العالم. أخلاقيات عمله وحنكته التجارية جعلا منه أحد أنجح رجال الأعمال في الترفيه.`,
    style: 'طاقة عالية، استهزاء بالنفس، كوميديا جسدية، رواية قصصية يومية',
    achievements: [
      'جولات عالمية متعددة بطاقة كاملة في الملاعب',
      'أعلى الجولات الكوميدية إيرادات في العالم',
      'قائمة Time 100 للشخصيات الأكثر تأثيرًا',
      'Producers Guild Award',
      'شركة إنتاج ناجحة',
      'نجمة على ممشى المشاهير في هوليوود',
    ],
  },
];
